var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var Throw = (function (_super) {
    __extends(Throw, _super);
    function Throw() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            throwed: undefined
        };
        _this.thrower = function (event) {
            _this.setState({ throwed: event });
        };
        return _this;
    }
    Throw.prototype.componentDidMount = function () {
        this.componentDidUpdate(this.props, this.state);
    };
    Throw.prototype.componentDidUpdate = function (oldProps, oldState) {
        if (this.props.when !== oldProps.when) {
            throw Promise.resolve(this.props.what);
        }
        if (oldState.throwed !== this.state.throwed) {
            throw Promise.resolve(this.state.throwed);
        }
    };
    Throw.prototype.shouldComponentUpdate = function (props, oldState) {
        return this.props.when !== props.when || this.state.throwed !== oldState.throwed;
    };
    Throw.prototype.render = function () {
        if (!this.props.children) {
            return null;
        }
        return this.props.children(this.thrower);
    };
    return Throw;
}(React.Component));
export { Throw };
